import RemoteModal from './components/RemoteModal.vue';

/**
 * Directive
 */

export function bindListeners(events, el, listener) {
    events.forEach(e => {
        el.removeEventListener(e, el._remoteModalListener);
        el.addEventListener(e, el._remoteModalListener = listener);
    });
}

export function unbindListeners(events, el) {
    events.forEach(e => {
        el.removeEventListener(e, el._remoteModalListener);
    });
}

export function modalId({ modifiers, value }) {
    return (modifiers||[])[0] || value || null;
}

export function hasRemoteModalAtRoot(vm) {
    return vm.$root.$children.some(component => component.$options.name === RemoteModal.name);
}
